// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Subtitle_subtitle__wA1ZK","subtitle--white":"Subtitle_subtitle--white__W4UTH"};